import ExtraDetailWithDrawer from './ExtraDetailWithDrawer';

export default ExtraDetailWithDrawer;
